// PR-I-83: contrato del agregador GET /api/v1/bookings/summary/.
// El back usa djangorestframework_camel_case; el front recibe camelCase directo.
// Mantener este archivo alineado con la definición del back (owner: back-dev PR-I-83-back).

export type BookingType = 'experience' | 'introduction' | 'expertise'

export type BookingBucket = 'active' | 'pending' | 'past'

export interface BookingCounterparty {
  id: number
  name: string
  avatar: string | null
}

export interface BookingPrice {
  amount: string
  currency: string
  unit: 'hour' | 'total' | null
}

/**
 * Fields adicionales que emite el back solo para type === 'experience'
 * (PR-I-84). Todos opcionales: si el back no los manda, la card los omite.
 */
export interface BookingExperienceExtra {
  experienceId?: number | null
  experienceDateId?: number | null
  location?: string | null // "City, Country"
  duration?: string | number | null // ej "7"
  durationType?: string | null // "hours" | "days" | "weeks" | ...
  maxGuests?: string | number | null // total_max_guests del Experience
  audienceType?: string | null // "2" => Only Adults; otro => Family Friendly
  pricePerGuest?: string | null // decimal como string
  categories?: string[] | null // chips "LIFESTYLE ..." arriba de la descripcion
  description?: string | null // descripcion libre del Experience
}

export interface BookingItem {
  id: string // ej "experience-42" -- key estable global entre buckets/tipos
  type: BookingType
  sourceId: number // id numérico original en la tabla de origen
  status: string // "confirmed", "pending", etc. (string libre del back)
  createdAt: string // ISO 8601
  scheduledAt: string | null // ISO 8601
  acceptDeadline?: string // ISO 8601, solo intros pending. Ausente => chip no se muestra
  title: string
  subtitle: string | null // ej "General Introduction"
  image: string | null
  topic: string | null
  message: string | null
  counterparty: BookingCounterparty | null
  guestsCount: number | null // solo cuando type === 'experience'
  price: BookingPrice | null
  // Poblado por el back para type === 'expertise' cuando la solicitud ya tiene
  // hilo abierto (chat.Conversation con reverse OneToOne expertise_request).
  // La card lo usa para saltar a /messages?uuid=... — mismo patron que la vista
  // del experto en /my-expertise. `null` mientras el hilo no exista aun.
  conversationUuid?: string | null
  extra?: BookingExperienceExtra | null // solo poblado en type === 'experience'
}

export interface BookingsSummary {
  active: BookingItem[]
  pending: BookingItem[]
  past: BookingItem[]
}

// UI-only helpers -------------------------------------------------------------

export type BookingTypeFilter = 'all' | 'experiences' | 'introductions' | 'expertise'

// Mapea el filtro plural del UI al tipo singular del contrato del back.
export const TYPE_FILTER_TO_TYPE: Record<Exclude<BookingTypeFilter, 'all'>, BookingType> = {
  experiences: 'experience',
  introductions: 'introduction',
  expertise: 'expertise',
}
